import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/baysgaia-site/baysgaia-site/app/cases/own-projects/youtube-channel/CaseDetailClient.tsx");
